/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstSupplier } from './MstSupplier';
import {
    MstSupplierFromJSON,
    MstSupplierFromJSONTyped,
    MstSupplierToJSON,
    MstSupplierToJSONTyped,
} from './MstSupplier';

/**
 * 
 * @export
 * @interface Supplier
 */
export interface Supplier {
    /**
     * 
     * @type {number}
     * @memberof Supplier
     */
    datacount: number | null;
    /**
     * 
     * @type {number}
     * @memberof Supplier
     */
    maxcount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Supplier
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {Array<MstSupplier>}
     * @memberof Supplier
     */
    list: Array<MstSupplier>;
}

/**
 * Check if a given object implements the Supplier interface.
 */
export function instanceOfSupplier(value: object): value is Supplier {
    if (!('datacount' in value) || value['datacount'] === undefined) return false;
    if (!('maxcount' in value) || value['maxcount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('list' in value) || value['list'] === undefined) return false;
    return true;
}

export function SupplierFromJSON(json: any): Supplier {
    return SupplierFromJSONTyped(json, false);
}

export function SupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): Supplier {
    if (json == null) {
        return json;
    }
    return {
        
        'datacount': json['datacount'],
        'maxcount': json['maxcount'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'list': ((json['list'] as Array<any>).map(MstSupplierFromJSON)),
    };
}

export function SupplierToJSON(json: any): Supplier {
    return SupplierToJSONTyped(json, false);
}

export function SupplierToJSONTyped(value?: Supplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datacount': value['datacount'],
        'maxcount': value['maxcount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'list': ((value['list'] as Array<any>).map(MstSupplierToJSON)),
    };
}

